export default __webpack_public_path__ + "static/media/sprkl.c155f947.jpg";